import React, { useContext } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ViewHistoryModal from 'modules/real-property-tax/land/land-application/components/land-history/modals/ViewHistoryModal';
import * as actions from '../action';

/* eslint-disable react/no-unescaped-entities */
function MemorandaModal({ memorandaData, type }) {
  const setModal = useContext(ModalContext);

  const createMarkup = (text) => {
    return { __html: text };
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    setModal({
      title: 'View History',
      isOpen: true,
      content: <ViewHistoryModal dataInfo={memorandaData} />,
      modalSize: 'modal-lg',
    });
  };

  return (
    <div
      className="flex  mb-1 p-3 overflow-scroll"
      style={{ height: '80vh', overflowY: 'scroll', scrollbarWidth: 'none' }}
    >
      {type === 'history' && (
        <div className="">
          <button onClick={handleGoBack} type="button" className="btn btn-link">
            <i className="fas fa-chevron-left back-login" />
          </button>
        </div>
      )}
      <div className="col-12 mt-1">
        <span className="transaction-text p-0">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={createMarkup(
              _.get(memorandaData, 'attributes.memoranda') || '--'
            )}
          />
        </span>
      </div>
    </div>
  );
}

MemorandaModal.defaultProps = {
  type: '',
};

MemorandaModal.propTypes = {
  memorandaData: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MemorandaModal);
